<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: TitleGroup                                            |
| Section: atoms                                                   |
| Purpose: Section heading group with label, title, and link CTA.  |
+------------------------------------------------------------------+
-->
<template>
    <div class="TitleGroup_container">
        <div v-if="!showH3Only" class="TitleGroup_wrapper">
            <p class="eyebrow" :class="{ 'text-white': isWhiteText, 'text-black': !isWhiteText }">{{ label }}</p>
            <h2 :class="{ 'text-white': isWhiteText, 'text-black': !isWhiteText }" v-html="title"></h2>
        </div>
        <h3 v-if="showH3Only" :class="{ 'text-white': isWhiteText, 'text-black': !isWhiteText }">
            <slot>{{ title }}</slot>
        </h3>

        <!-- Use a button instead of an anchor -->
        <button v-if="showLink" @click="handleLinkClick"
            :class="{ 'text-white': isWhiteText, 'text-black': !isWhiteText }" class="TitleGroup_button">
            {{ linkLabel }}
            <img src="@/assets/icons/arrow-right.svg" alt="Arrow Icon">
        </button>
    </div>
</template>

<script>
export default {
    name: 'TitleGroup',
    props: {
        label: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        isWhiteText: {
            type: Boolean,
            default: false
        },
        showLink: {
            type: Boolean,
            default: false
        },
        linkLabel: {
            type: String,
            default: 'linkLabel'
        },
        showH3Only: {
            type: Boolean,
            default: false
        },
        linkClick: {
            type: Function,
            default: null // Default is null, meaning no custom click handler
        }
    },
    methods: {
        handleLinkClick(event) {
            // Check if linkClick is provided, and call it if so
            if (this.linkClick) {
                this.linkClick(event);
            }
        }
    }
}
</script>

<style scoped>
.TitleGroup_container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    gap: 20px;
}

h3 {
    margin-top: 32px;
    display: inline-flex;
    flex-direction: row;
    gap: 8px;
}

.TitleGroup_button {
    display: flex;
    align-items: center;
    height: fit-content;
    gap: 8px;
    font-weight: 600;
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    color: var(--brand-text-light);
    /* Adjust as needed */
}

.TitleGroup_button:hover {
    text-decoration: underline;
}

.text-white {
    color: var(--brand-text-light);
}

.text-black {
    color: var(--brand-text-dark);
}
</style>
